/**
 * Validates if a password meets our strong password requirements:
 * - Minimum 8 characters
 * - At least 1 uppercase letter
 * - At least 1 lowercase letter
 * - At least 1 number
 * - At least 1 special character (@$!%*?&._-)
 * @param {string} password 
 * @returns {{isValid: boolean, errorKey: string, messagePL: string, messageEN: string}}
 */
export const validatePassword = (password) => {
  if (!password) {
    return { isValid: false, errorKey: "required", messagePL: "Hasło jest wymagane", messageEN: "Password is required" };
  }
  
  const minLength = password.length >= 8;
  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[@$!%*?&._-]/.test(password);

  const isValid = minLength && hasUpper && hasLower && hasNumber && hasSpecial;

  let errorsPL = [];
  let errorsEN = [];
  if (!minLength) { errorsPL.push("min. 8 znaków"); errorsEN.push("min. 8 characters"); }
  if (!hasUpper) { errorsPL.push("wielka litera"); errorsEN.push("uppercase letter"); }
  if (!hasLower) { errorsPL.push("mała litera"); errorsEN.push("lowercase letter"); }
  if (!hasNumber) { errorsPL.push("cyfra"); errorsEN.push("number"); }
  if (!hasSpecial) { errorsPL.push("znak specjalny (@$!%*?&._-)"); errorsEN.push("special character (@$!%*?&._-)"); }

  return {
    isValid,
    errorKey: isValid ? "" : "requirements_unmet",
    messagePL: `Hasło musi zawierać: ${errorsPL.join(", ")}.`,
    messageEN: `Password must contain: ${errorsEN.join(", ")}.`
  };
};
